import {
  login,
  register,
  getProxySettings,
  updateProxySettings,
  getSecurityScore,
  updateProfileSettings,
  getUser,
  getPreferredQueue,
  uploadProfilePicture,
  getProfilePicture,
  getTwo2fa,
  verifyOTP,
  cancel2fa,
  updateApiKey,
  getAccessLogs,
  getApiRequestHistory,
  oAuthDiscord,
  oAuthDiscordLogin,
  verifyEmail,
  forgotPassword,
  resetPassword,
  getIPRestrictionStatus,
  updateIPRestrictionStatus,
  getActiveSessions,
  deleteActiveSessions,
  getNotifications,
  deleteAllNotifications,
  deleteNotificationById,
  oAuthGoogleLogin,
  oAuthGoogle,
  getAuthIpParams,
  authorizeIP
} from "../api/user";
import ResolvedException from "./exception";
import store from "../store";

export const handleLogin = async (email, password, rememberMe) => {
  try {
    const response = await login(email, password, rememberMe);
    const responseData = response.data.data;
    const loggedInData = {
      authToken:
        response.data.data[
        "Dont_Give_This_Token_To_Anyone_Ever_Support_Will_Never_Ask_For_This_Token"
        ],
      email: responseData.user.email,
      verifiedEmail: responseData.user.isVerified,
      apiKey: responseData.user.apiKey,
      authorizedIPs: [],
      browserNotifs: [],
      ipRestrict: false,
      lastLoginIP: '',
      notificationEmail: responseData.user.email,
      notifications: [],
      notificationsEnabled: false,
      rememberMe: true,
      twoFactorAuthEnabled: responseData.user.TwoFA,
      authenticated: responseData.user.isVerified,
      activeBrowserSessions: 0,
      loggedIn: true,
      userName: responseData.user.username,
    };
    await store.dispatch("userStore/login", loggedInData);
    return response;
  } catch (e) {
    console.log(e);
    throw new ResolvedException(e.response.data.message, e.response.data.error);
  }
};

export const handleGetUser = async () => {
  try {
    const response = await getUser(
      store.getters["userStore/getAuthToken"],
      store.getters["userStore/getEmail"]
    );
    // console.log(response.data);
    const userData = {
      email: response.data.data.user.email,
      verifiedEmail: response.data.data.user.verifiedEmail,
      apiKey: response.data.data.user.apiKey,
      authorizedIPs: response.data.data.user.authorizedIPs,
      browserNotifs: response.data.data.user.browserNotifs,
      ipRestrict: response.data.data.user.ipRestrict,
      lastLoginIP: response.data.data.user.lastLoginIP,
      notificationEmail: response.data.data.user.notificationEmail,
      notifications: response.data.data.user.notifications,
      notificationsEnabled: response.data.data.user.notificationsEnabled,
      rememberMe: response.data.data.user.rememberMe,
      twoFactorAuthEnabled: response.data.data.user.twoFactorAuthEnabled,
      authenticated: response.data.data.user.verifiedEmail,
      activeBrowserSessions: response.data.data.user.activeBrowserSessions,
      loggedIn: true,
      userName: response.data.data.user.userName,
    };

    await store.dispatch("userStore/update", userData);
    await handlePreferredQueue();

    return response;
  } catch (e) {
    throw new ResolvedException(e.response.data.message, e.response.data.error);
  }
};

export const handleVerifyEmail = async (token) => {
  try {
    const response = await verifyEmail(token);
    await store.commit('userStore/setVerifiedEmail', true)
    return response
  } catch (e) {
    throw new ResolvedException(e.response.data.message, e.response.data.error);

  }
}

export const handleRegister = async (email, password, rememberMe, token, rcode) => {
  try {
    const response = await register(email, password, rememberMe, token, rcode);
    const responseData = response.data.data;
    const loggedInData = {
      authToken:
        response.data.data[
        "Dont_Give_This_Token_To_Anyone_Ever_Support_Will_Never_Ask_For_This_Token"
        ],
      email: responseData.user.email,
      verifiedEmail: responseData.user.isVerified,
      apiKey: responseData.user.apiKey,
      authorizedIPs: [],
      browserNotifs: [],
      ipRestrict: false,
      lastLoginIP: '',
      notificationEmail: responseData.user.email,
      notifications: [],
      notificationsEnabled: false,
      rememberMe: true,
      twoFactorAuthEnabled: responseData.user.TwoFA,
      authenticated: responseData.user.isVerified,
      activeBrowserSessions: 0,
      loggedIn: true,
      userName: responseData.user.username,
    };
    await store.dispatch("userStore/login", loggedInData);
  
    return response;
  } catch (e) {
    throw new ResolvedException(e.response.data.message, e.response.data.error);
  }
};


export const handleResetPassword = async (tok, password) => {
  try {
    const response = await resetPassword(tok, password)
    return response
  } catch (e) {
    throw new ResolvedException(e.response.data.message, e.response.data.error);

  }
}

export const handleForgotPassword = async (email) => {
  try {
    const response = await forgotPassword(email)
    return response
  } catch (e) {
    throw new ResolvedException(e.response.data.message, e.response.data.error);

  }
}


export const handleGetAuthIPParams = async (token) => {
  try{
    const response = await getAuthIpParams(token);
    return response
  }catch(e){
    throw new ResolvedException(e.response.data.message, e.response.data.error);
  }
}

export const handleAuthorizeIP = async (token) => {
  try{
    const response = await authorizeIP(token);
    return response;
  }catch(e){
    throw new ResolvedException(e.response.data.message, e.response.data.error);
  }
}

export const handleUploadProfilePic = async (fileImage) => {
  try {
    const response = await uploadProfilePicture(
      store.getters["userStore/getAuthToken"],
      fileImage
    );
    return response;
  } catch (e) {
    throw new ResolvedException(e.response.data.message, e.response.data.error);
  }
};

export const handleDiscordOAuth = async (code) => {
  try {
    const response = await oAuthDiscord(code);
    const loggedInData = {
      authToken:
        response.data.data.body[
        "Authorization"
        ],
      email: response.data.data.body.user.email,
      verifiedEmail: true,
      apiKey: response.data.data.body.user.apiKey,
      authorizedIPs: response.data.data.body.user.authorizedIPs,
      browserNotifs: response.data.data.body.user.browserNotifs,
      ipRestrict: response.data.data.body.user.ipRestrict,
      lastLoginIP: response.data.data.body.user.lastLoginIP,
      notificationEmail: response.data.data.body.user.notificationEmail,
      notifications: response.data.data.body.user.notifications,
      notificationsEnabled: response.data.data.body.user.notificationsEnabled,
      rememberMe: response.data.data.body.user.rememberMe,
      twoFactorAuthEnabled: response.data.data.body.user.twoFactorAuthEnabled,
      authenticated: response.data.data.body.user.verifiedEmail,
      activeBrowserSessions: response.data.data.body.user.activeBrowserSessions,
      loggedIn: true,
      userName: response.data.data.body.user.userName,
    };
    await store.dispatch("userStore/login", loggedInData);
    return response;
  } catch (e) {
    throw new ResolvedException(e.response.data.message, e.response.data.error);
  }
};


export const handleDiscordOAuthLogin = async (code) => {
  // console.log('Loggin to discord...')
  try {
    const response = await oAuthDiscordLogin(code);
    const loggedInData = {
      authToken:
        response.data.data.body[
        "Authorization"
        ],
      email: response.data.data.body.user.email,
      verifiedEmail: true,
      apiKey: response.data.data.body.user.apiKey,
      authorizedIPs: response.data.data.body.user.authorizedIPs,
      browserNotifs: response.data.data.body.user.browserNotifs,
      ipRestrict: response.data.data.body.user.ipRestrict,
      lastLoginIP: response.data.data.body.user.lastLoginIP,
      notificationEmail: response.data.data.body.user.notificationEmail,
      notifications: response.data.data.body.user.notifications,
      notificationsEnabled: response.data.data.body.user.notificationsEnabled,
      rememberMe: response.data.data.body.user.rememberMe,
      twoFactorAuthEnabled: response.data.data.body.user.twoFactorAuthEnabled,
      authenticated: response.data.data.body.user.verifiedEmail,
      activeBrowserSessions: response.data.data.body.user.activeBrowserSessions,
      loggedIn: true,
      userName: response.data.data.body.user.userName,
    };
    await store.dispatch("userStore/login", loggedInData);
    return response;
  } catch (e) {
    throw new ResolvedException(e.response.data.message, e.response.data.error);
  }
};

export const handleGoogleOAuth = async (code) => {
  try {
    const response = await oAuthGoogle(code);
    const loggedInData = {
      authToken:
        response.data.data.body[
        "Authorization"
        ],
      email: response.data.data.body.user.email,
      verifiedEmail: true,
      apiKey: response.data.data.body.user.apiKey,
      authorizedIPs: response.data.data.body.user.authorizedIPs,
      browserNotifs: response.data.data.body.user.browserNotifs,
      ipRestrict: response.data.data.body.user.ipRestrict,
      lastLoginIP: response.data.data.body.user.lastLoginIP,
      notificationEmail: response.data.data.body.user.notificationEmail,
      notifications: response.data.data.body.user.notifications,
      notificationsEnabled: response.data.data.body.user.notificationsEnabled,
      rememberMe: response.data.data.body.user.rememberMe,
      twoFactorAuthEnabled: response.data.data.body.user.twoFactorAuthEnabled,
      authenticated: response.data.data.body.user.verifiedEmail,
      activeBrowserSessions: response.data.data.body.user.activeBrowserSessions,
      loggedIn: true,
      userName: response.data.data.body.user.userName,
    };
    await store.dispatch("userStore/login", loggedInData);
    return response;
  } catch (e) {
    throw new ResolvedException(e.response.data.message, e.response.data.error);
  }
};


export const handleGoogleOAuthLogin = async (code) => {
  // console.log('Loggin to discord...')
  try {
    const response = await oAuthGoogleLogin(code);
    const loggedInData = {
      authToken:
        response.data.data.body[
        "Authorization"
        ],
      email: response.data.data.body.user.email,
      verifiedEmail: true,
      apiKey: response.data.data.body.user.apiKey,
      authorizedIPs: response.data.data.body.user.authorizedIPs,
      browserNotifs: response.data.data.body.user.browserNotifs,
      ipRestrict: response.data.data.body.user.ipRestrict,
      lastLoginIP: response.data.data.body.user.lastLoginIP,
      notificationEmail: response.data.data.body.user.notificationEmail,
      notifications: response.data.data.body.user.notifications,
      notificationsEnabled: response.data.data.body.user.notificationsEnabled,
      rememberMe: response.data.data.body.user.rememberMe,
      twoFactorAuthEnabled: response.data.data.body.user.twoFactorAuthEnabled,
      authenticated: response.data.data.body.user.verifiedEmail,
      activeBrowserSessions: response.data.data.body.user.activeBrowserSessions,
      loggedIn: true,
      userName: response.data.data.body.user.userName,
    };
    await store.dispatch("userStore/login", loggedInData);
    return response;
  } catch (e) {
    throw new ResolvedException(e.response.data.message, e.response.data.error);
  }
};


export const handleGetProfilePic = async () => {
  try {
    const response = await getProfilePicture(
      store.getters["userStore/getAuthToken"],
      store.getters["userStore/getEmail"]
    );
    return response;
  } catch (e) {
    throw new ResolvedException(e.response.data.message, e.response.data.error);
  }
};

export const handleGetProxySettings = async () => {
  try {
    const response = await getProxySettings(
      store.getters["userStore/getAuthToken"]
    );
    store.commit(
      "userStore/setFilterProxies",
      response.data.data["filter-proxies"]
    );
    store.commit(
      "userStore/setResolvedProxies",
      response.data.data["resolved-proxies"]
    );

    return response;
  } catch (e) {
    throw new ResolvedException(e.response.data.message, e.response.data.error);
  }
};

export const handlePreferredQueue = async () => {
  try {
    const response = await getPreferredQueue(
      store.getters["userStore/getAuthToken"]
    );
    if (response.data.data.queueType == "Public") {
      store.commit("userStore/setPublicQueue", true);
      store.commit("userStore/setPrivateQueue", false);
    } else if (response.data.data.queueType == "Private") {
      store.commit("userStore/setPrivateQueue", true);
      store.commit("userStore/setPublicQueue", false);
    } else {
      store.commit("userStore/setPrivateQueue", false);
      store.commit("userStore/setPublicQueue", false);
    }

    return response;
  } catch (e) {
    throw new ResolvedException(e.response.data.message, e.response.data.error);
  }
};

export const handleUpdateProxySettings = async (filter, resolved) => {
  try {
    const response = await updateProxySettings(
      store.getters["userStore/getAuthToken"],
      filter,
      resolved
    );
    handleGetProxySettings();
    return response;
  } catch (e) {
    throw new ResolvedException(e.response.data.message, e.response.data.error);
  }
};

export const handleGetSecurityScore = async () => {
  try {
    const response = await getSecurityScore(
      store.getters["userStore/getAuthToken"]
    );
    store.commit(
      "userStore/setSecurityScore",
      response.data.data.securityThreshold
    );
    return response;
  } catch (e) {
    throw new ResolvedException(e.response.data.message, e.response.data.error);
  }
};

export const handleUpdateProfileSettings = async () => {
  try {
    const response = await updateProfileSettings(
      store.getters["userStore/getAuthToken"],
      store.getters["userStore/getSettingsPayload"]
    );
    return response;
  } catch (e) {
    throw new ResolvedException(e.response.data.message, e.response.data.error);
  }
};

export const handleGetTwo2fa = async () => {
  try {
    const response = await getTwo2fa(store.getters["userStore/getAuthToken"]);
    return response;
  } catch (e) {
    throw new ResolvedException(e.response.data.message, e.response.data.error);
  }
};

export const handleVerifyOTP = async (otp) => {
  try {
    const response = await verifyOTP(
      store.getters["userStore/getAuthToken"],
      otp
    );
    return response;
  } catch (e) {
    throw new ResolvedException(e.response.data.message, e.response.data.error);
  }
};

export const handleCancel2fa = async () => {
  try {
    const response = await cancel2fa(store.getters["userStore/getAuthToken"]);
    return response;
  } catch (e) {
    throw new ResolvedException(e.response.data.message, e.response.data.error);
  }
};

export const handleUpdateApiKey = async () => {
  try {
    const response = await updateApiKey(
      store.getters["userStore/getAuthToken"]
    );
    store.commit("userStore/setApiKey", response.data.data.apiKey);
    return response;
  } catch (e) {
    throw new ResolvedException(e.response.data.message, e.response.data.error);
  }
};

export const handleGetAccessLogs = async (page) => {
  try {
    const response = await getAccessLogs(
      store.getters["userStore/getAuthToken"],
      page
    );
    return response;
  } catch (e) {
    throw new ResolvedException(e.response.data.message, e.response.data.error);
  }
};

export const handleGetApiRequestHistory = async (page) => {
  try {
    const response = await getApiRequestHistory(
      store.getters["userStore/getAuthToken"],
      page
    );
    return response;
  } catch (e) {
    throw new ResolvedException(e.response.data.message, e.response.data.error);
  }
};


export const handleGetNotificationHistory = async (page) => {
  try {
    const response = await getNotifications(store.getters['userStore/getAuthToken'], page)
    return response
  } catch (e) {
    throw new ResolvedException(e.response.data.message, e.response.data.error);
  }
}

export const handleGetIPRestriction = async () => {
  try {
    const response = await getIPRestrictionStatus(store.getters['userStore/getAuthToken'])
    store.commit("userStore/setIpRestrict", response.data.data.ipRestriction);
    return response;
  } catch (e) {
    throw new ResolvedException(e.response.data.message, e.response.data.error);

  }
}

export const handleUpdateIPRestriction = async (status) => {
  try {
    const response = await updateIPRestrictionStatus(store.getters['userStore/getAuthToken'], status)
    handleGetIPRestriction()
    return response;
  } catch (e) {
    throw new ResolvedException(e.response.data.message, e.response.data.error);

  }
}


export const handleGetBrowserSessions = async () => {
  const response = await getActiveSessions(store.getters['userStore/getAuthToken'])
  store.commit('userStore/setActiveBrowserSessions', response.data.data.activeSessions)
}

export const handleDeleteBrowserSessions = async () => {
  await deleteActiveSessions(store.getters['userStore/getAuthToken'])
  handleGetBrowserSessions();
}

export const handleDeleteAllNotifications = async () => {
  await deleteAllNotifications(store.getters['userStore/getAuthToken'])
  await handleGetNotificationHistory()
}

export const handleDeleteNotificationById = async (id) => {
  try{
    const response = await deleteNotificationById(store.getters['userStore/getAuthToken'], id)
    await handleGetNotificationHistory()
    return response
  }catch(e){
    throw new ResolvedException(e.response.data.message, e.response.data.error);
  }
}